import $ from "jquery";

const form = () => {
  const init = () => {
    insertPostTitle();
    formPopup();
  };

  const insertPostTitle = () => {
    const el = {
      title: ".mi-PostTitle .et_pb_text_inner",
      input: ".mi-ContactForm p input#et_pb_contact_post_title_0",
    };

    if ($(el.title).length === 0) return;

    $(() => {
      $(el.input).attr("value", $(el.title).text());
      $(el.input).siblings('label').hide();
    })
  };

  // validate email input
  const validateEmail = (email) => {
    var regex = /^[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*$/;
    return regex.test(email);
  }

  const formPopup = () => {
    const el = {
      header: "#main-header",
      topHeader: "#top-header",
      form: ".mi-ContactForm form",
      formInput1: ".mi-ContactForm p input#et_pb_contact_naam_0",
      formInput2: ".mi-ContactForm p input#et_pb_contact_telefoonnummer_0",
      formInput3: ".mi-ContactForm p input#et_pb_contact_e-mail_adres_0",
      formInput4: ".mi-ContactForm p input#et_pb_contact_woonplaats_0",
      modalSection: ".mi-PopupSection",
      modal: ".mi-FormPopup",
      modalBg: ".bg-overlay",
      button: ".mi-ContactForm button.et_pb_contact_submit et_pb_button",
      buttonClose: ".mi-FormPopup .js-button-popup",
    };

    if ($(el.modal).length === 0) return;

    $(el.form).on("submit", (e) => {
      if ($(el.formInput1).val() !== '' && $(el.formInput2).val() !== '' && validateEmail($(el.formInput3).val()) && $(el.formInput4).val() !== '') {
        e.preventDefault();

        console.log(validateEmail($(el.formInput3).val()))

        $(el.modalSection).show();
        $(el.header).css('z-index', '1');
        $(el.topHeader).css('z-index', '1');
        $('body').css({
          'overflow': 'hidden',
          'height': '100vh'
        });
        $(el.modal).show();
      }
    })
    $(el.modalBg + ' , ' + el.buttonClose).on("click", () => {
      $(el.header).css('z-index', '9999999');
      $(el.topHeader).css('z-index', '100000');
      $('body').css({
        'overflow': 'unset',
        'height': 'unset'
      });
      // location.reload();
      $(el.modal).hide();
    })
  };

  init();
};

try {
  form();
} catch (e) {
  console.error(e);
}
